import React from 'react';
import { IconProps } from './types';

export const CoinInfoIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_5501_5268)'>
        <path d='M24 0H0V24H24V0Z' fill={color} fillOpacity='0.01' />
        <path
          d='M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z'
          stroke={color}
          strokeLinejoin='round'
        />
        <path
          d='M14.8284 11.2929L12.7071 9.17161C12.3166 8.78109 11.6834 8.78109 11.2929 9.17161L9.17157 11.2929C8.78105 11.6835 8.78105 12.3166 9.17157 12.7071L11.2929 14.8285C11.6834 15.219 12.3166 15.219 12.7071 14.8285L14.8284 12.7071C15.219 12.3166 15.219 11.6835 14.8284 11.2929Z'
          stroke='#DFF60D'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_5501_5268'>
          <rect width='24' height='24' fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
